function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#597b8d;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Logo",
  className: "cls-1",
  d: "M89.76,29.17c.06.88.06,1.76.06,2.65,0,27.11-20.64,58.37-58.37,58.37h0A58.13,58.13,0,0,1,0,81a41.91,41.91,0,0,0,4.88.29,41.15,41.15,0,0,0,25.48-8.8A20.53,20.53,0,0,1,11.2,58.23a20.41,20.41,0,0,0,9.26-.36A20.52,20.52,0,0,1,4,37.76V37.5a20.41,20.41,0,0,0,9.31,2.57A20.53,20.53,0,0,1,7,12.68,58.26,58.26,0,0,0,49.24,34.12a20.54,20.54,0,0,1,35-18.71,41.29,41.29,0,0,0,13-5,20.61,20.61,0,0,1-9,11.34A40.89,40.89,0,0,0,100,18.55,41.69,41.69,0,0,1,89.76,29.17Z"
});

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Twitter Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.73656c86.svg";
export { ForwardRef as ReactComponent };